import React from 'react'
import { Text } from '@/components/Text'

import { SalePriceWrapper, SalePercent, Cross } from './ProductViewStyles'

import { formatPrice, diffInPercent } from '@/utils/Helpers'

interface ProductPriceProps {
  price: string
  salePrice: string
  currency: string
}

export const ProductPrice: React.VFC<ProductPriceProps> = ({ price, salePrice, currency }) => (
  <>
    {salePrice ? (
      <SalePriceWrapper>
        <Cross>
          <Text textColor="textDefault" fontSize="l" my="auto">
            {formatPrice(price, currency)}
          </Text>
        </Cross>
        <Text textColor="primary" fontSize="xl" fontWeight="bold" mx="1.5rem">
          {formatPrice(salePrice, currency)}
        </Text>
        <SalePercent>
          <Text textColor="primary" fontSize="l" fontWeight="bold" my="auto">
            -{diffInPercent(Number.parseFloat(price), Number.parseFloat(salePrice))}%
          </Text>
        </SalePercent>
      </SalePriceWrapper>
    ) : (
      formatPrice(price, currency)
    )}
  </>
)
